import React, { useEffect, useState } from 'react'
import style from './ProjectMap.module.scss'

import Map from './../../assets/Map.png'
import PlaceSvg from "../PlaceSvg/PlaceSvg.jsx";

export default function ProjectMap( {mapDate} ) {
    const [activeIndex, setActiveIndex] = useState(null);

    useEffect(() => {
        const handleClickOutside = ( event ) => {
            if (!event.target.closest(`.${style.placeContainer}`)) {
                setActiveIndex(null);
            }
        };

        document.addEventListener('click', handleClickOutside);

        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);



    const handleDescriptionClick = ( event ) => {
        event.stopPropagation();
    };

    return (
        <div className={style.projectMap}>
            <div className='container'>
                <h2 className={style.title}>Георгафия проектов</h2>
                <div className={style.map}>
                    <img src={Map} alt="Map"/>
                    <div className={style.place}>
                        {mapDate.map(( date, index ) => (
                            <PlaceSvg
                                key={index}
                                setActiveIndex={setActiveIndex}
                                id={date.id}
                                description={date.attributes.Description}
                                left={date.attributes.Left}
                                top={date.attributes.Top}
                                handleDescriptionClick={handleDescriptionClick}
                                activeIndex={activeIndex}
                            />
                        ))}

                    </div>
                </div>
            </div>
        </div>
    )
}
